import React, { useEffect } from "react";
import '../assets/js/carrer.js';

function AdminCarrer() {
    useEffect(() => {
        if (window.loadCarrers) {
            window.loadCarrers();
        }
    }, []);
    
    return (
        <div>
            <h1 className="bg-warning p-3 ">Admin Carrer</h1>

            <section>
                <div className="p-2 d-flex justify-content-between align-items-center">
                    <h2>All Carrers</h2>
                    <a href="#" class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#carrerModal">
                        <i class="fa-solid fa-plus"></i> Add
                    </a>
                </div>
                <div className="row px-lg-2">
                    <div className="col-12 overflow-scroll">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Sr No.</th>
                                    <th scope="col">Position</th>
                                    <th scope="col">Caurse</th>
                                    <th scope="col">Job Type</th>
                                    <th scope="col">Experience</th>
                                    <th scope="col">Skills</th>
                                    <th scope="col">PostDate</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody id="allCarrerData"></tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Carrer Model */}
            <div class="modal fade" id="carrerModal" tabindex="-1" aria-labelledby="carrerModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content overflow-scroll">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title text-white" id="carrerModalLabel">Add Carrer</h5>
                            <button type="button" class="btn-close border border-0 text-white btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="addCarrerForm" enctype="multipart/form-data" class="p-3">
                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Position</b></label>
                                        <input type="text" name="position" id="position" class="form-control" required placeholder='enter position' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Course</b></label>
                                        <input type="text" name="course" id="course" class="form-control" required placeholder='enter course' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Job Type</b></label>
                                        <input type="text" name="jobType" id="jobType" class="form-control" required placeholder='enter job type' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Experience</b></label>
                                        <input type="text" name="experience" id="experience" class="form-control" required placeholder='enter experience' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Skills</b></label>
                                        <input type="text" name="skills" id="skills" class="form-control" required placeholder='enter skills' />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Description</b></label>
                                        <textarea class="form-control" placeholder="description here..." id="description" style={{ height: "100px" }}></textarea>
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn fw-semibold btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Carrer Model */}


            {/* Carrer Model */}
            <div class="modal fade" id="editCarrerModal" tabindex="-1" aria-labelledby="editCarrerModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content overflow-scroll">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title text-white" id="editCarrerModalLabel">Edit Carrer</h5>
                            <button type="button" class="btn-close border border-0 text-white btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="editCarrerForm" enctype="multipart/form-data" class="p-3">
                            <div class="modal-body">
                                <input type="hidden" id="editId" />
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Position</b></label>
                                        <input type="text" id="editPosition" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Course</b></label>
                                        <input type="text" id="editCourse" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Job Type</b></label>
                                        <input type="text" id="editJobType" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Experience</b></label>
                                        <input type="text" id="editExperience" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Skills</b></label>
                                        <input type="text" id="editSkills" class="form-control" />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Description</b></label>
                                        <textarea class="form-control" id="editDescription" style={{ height: "100px" }}></textarea>
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn fw-semibold btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Carrer Model */}

            {/* ✅ Universal Success Modal */}
            <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content border-0 shadow-lg">

                        <div class="modal-header bg-success text-white">
                            <h5 class="modal-title fw-bold" id="successModalLabel">
                                <i class="bi bi-check-circle-fill me-2"></i> Success
                            </h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
                            </svg>
                            <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                        </div>

                        <div class="modal-footer border-0 justify-content-center">
                            <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
}

export default AdminCarrer;
